import { HttpService } from '@/shared/services'
import { CreateApprovalFlowStepDto } from './interfaces/CreateApprovalFlowStepDto'

import ApprovalStep from '../models/ApprovalStep'
import List from '@/shared/dtos/List'
import { UpdateApprovalFlowStepDto } from './interfaces/UpdateApprovalFlowStepInputDto'
import DeleteApprovalFlowStepInputDto from './interfaces/DeleteApprovalFlowStepInputDto'

const http = new HttpService()

export const createApprovalFlowSteps = async (
  approvers: CreateApprovalFlowStepDto
) => {
  const response = await http.post<CreateApprovalFlowStepDto, string>(
    `/approvalFlowSteps`,
    approvers
  )
  return response.data
}

export const getApprovalFlowSteps = async (approvalFlowId: string) => {
  const response = await http.get<List<ApprovalStep[]>>(
    `/approvalFlowSteps/${approvalFlowId}`
  )

  return response.data.data
}

export const updateApprovalFlowSteps = async (
  approvers: UpdateApprovalFlowStepDto
) => {
  const response = await http.put<UpdateApprovalFlowStepDto, string>(
    `/approvalFlowSteps`,
    approvers
  )
  return response.data
}

export const deleteApprovalFlowSteps = async (
  approvalFlowId: DeleteApprovalFlowStepInputDto
) => {
  const response = await http.post<DeleteApprovalFlowStepInputDto, string>(
    `/approvalFlowSteps/delete`,
    approvalFlowId
  )
  return response.data
}
